import React from 'react';
import {CheckBoxComp} from '../inputs/fields.component';
import SearchBoxComp from '../inputs/searchbox.component';
import TimeDropdownComp from './time-dropdown';
import DropdownComp from '../dropdown/dropdown';
import {OwnerList, WsList, OkrCategoryList} from './search-list-item';
import { withTranslation } from 'react-i18next';
import { getAiTypeActionLabelPlural, getAiTypeActionLabel } from '../../board/utils';

class GlobalSearchFiltersComp extends React.Component {
    constructor(props) {
        super(props);

        this.renderSearchOwnerList = this.renderSearchOwnerList.bind(this);
        this.renderSearchWsList = this.renderSearchWsList.bind(this);
        this.renderSearchOkrCatList = this.renderSearchOkrCatList.bind(this);
        this.filterOwnerLists = this.filterOwnerLists.bind(this);
        const userPermissions = this.props.userPermissions || {};
        this.executeModule = userPermissions.execute || false;
        this.goalModule = userPermissions.goal || false;
        this.meetingModule = userPermissions.meeting || false;
       
    }

    filterOwnerLists(values = []) {
        if (Array.isArray(values) && values.length) {
            values = values.filter( u => u.type == 1);
        }
        return values;
    }

    typeCheckboxes() {
        const { t } = this.props;
        let types = [];
        if (this.goalModule) {
            types.push({
                id: 2,
                label: t('Objectives and key results'),
                icons: 'icon icon-outline-bar_chart-24px'
             });
            if (this.props.enableKpiGlobalSearch) {
                types.push({
                    id: 8,
                    label: t('KPIs'),
                    icons: 'icon icon-kpi-24px'
                });
            }
        }
        if (this.executeModule) {
            types.push({
                id: 1,
                label: t('{{actionLabelPlural}} and workstreams', { actionLabelPlural: getAiTypeActionLabelPlural() }),
                icons: 'icon icon-action_item_24px'
            });
        }
        if (this.meetingModule) {
            types.push({
                id: 3,
                label: t('Meetings'),
                icons: 'icon icon-decision_24px'
            });
        }
        types = types.concat(
            {
                id: 4,
                label: t('Biz reviews'),
                icons: 'icon icon-biz_review-24px'
            }
        );
        types = types.concat(
            {
                id: 5,
                label: t('Teams'),
                icons: 'icon icon-working-group-24px'
            }
        );
        const filterType = this.props.state.filter.type;
        return types.map(type => 
            <CheckBoxComp
                key={'checkbox_types_' + type.id}
                name='type'
                label={type.label}
                id={'types_' + type.id}
                checkboxProps = {{
                    name: 'types_' + type.id,
                    checked: (filterType == type.id),
                    onChange: this.props.onChangeType,
                    value: type.id,
                    disabled: (filterType && filterType != type.id)
                }}
                icons={type.icons}
                labelClass={((filterType && filterType != type.id) ? 'disabledlabel' : '')}
                subclassDefined={((filterType && filterType != type.id) ? ' inLineBlkDisabled ' : '')}
            />
        );
    }

    getMeetTagOptions() {
        const { t } = this.props;
        return [
            {
                value: 0,
                name: t('All smartbullets')
            },
            {
                value: 2,
                name: t('Idea')
            },
            {
                value: 3,
                name: t('Decision')
            },
            {
                value: 8,
                name: t('Red')
            },
            {
                value: 9,
                name: t('Amber')
            },
            {
                value: 5,
                name: t('Green')
            },
            {
                value: 6,
                name: t('Discussion')
            },
            {
                value: 7,
                name: t('FYI')
            },
            {
                value: 4,
                name: t('Note')
            }
        ];
    }

    renderMeetTagOption(item) {
        let tag = item.value;
        if (tag == 0) {
            tag = '-1';
        }
        return (
            <div className="mtagoption">
                <div className="mtagoptionimg" data-tag={tag}></div>
                <div className="textAlignLeft">{item.name}</div>
            </div>
        );
    }

    showMoreOptions() {
        const {filter={}, showAdvancedOption = false} = this.props.state;
        const filterType = filter.type || '';
        const { t } = this.props;
        return (
            !showAdvancedOption ?
            <div className='show-advanced-option' onClick={() => this.props.showAdvancedFilters()}>{t('Advanced filtering options')}</div>
            :
            <div className='more-options-details'>
                <div className="label-with-dashes">
                    <div className="left">{t('More options')}</div>
                    <div className="right"></div>
                    <div className="clear"></div>
                </div>
                <div className='more-options-wrapper'>
                    { this.renderMoreOptions()}
                </div>
            </div>
        );
    }

    renderMoreOptions() {
        const { t } = this.props;
        const {filter={}, showAdvancedOption = false} = this.props.state;
        const filterType = filter.type || '';
        const actionLabel = getAiTypeActionLabel().toLowerCase();
        if (filterType == '') {
            let options = [];
            if (this.executeModule) {
                options.push({
                    id: 'hac',
                    label: t(`Hide ${actionLabel} comments`),
                    value: 1
                });
            }
            if (this.meetingModule) {
                options.push({
                    id: 'hmt',
                    label: t('Hide meeting topics and takeaways'),
                    value: 1
                });
            }
            if (this.goalModule) {
                options.push({
                    id: 'hoc',
                    label: t('Hide OKR comments'),
                    value: 1
                });
            }
            if (this.props.enableKpiGlobalSearch) {
                options.push({
                    id: 'hakpi',
                    label: t('Hide archived KPIs'),
                    value: 1
                });
            }
            /*if (this.goalModule) {
                options.push({
                    id: 'htw',
                    label: 'Hide archived teams and workstreams',
                    value: 1
                });
            }*/
            return options.map((type) => 
                <CheckBoxComp
                    key={'checkbox_types_' + type.id}
                    label={type.label}
                    id={type.id}
                    checkboxProps = {{
                        name:type.id,
                        checked: (filter[type.id] == type.value),
                        onChange: this.props.onChangeCheckbox,
                        value: type.value
                    }}
                />
            );
        }
        else if (filterType == '2' && this.goalModule) {
            const options = [
                {
                    id: 'hoc',
                    label: t(`Hide OKR comments`),
                    value: 1
                },
                {
                    id: 'hopen',
                    label: t('Hide open OKR'),
                    value: 1,
                },
                {
                    id: 'hclosed',
                    label: t('Hide closed OKR'),
                    value: 1
                }
                /*,
                {
                    id: 'hat',
                    label: 'Hide archived teams',
                    value: 1
                }*/
            ];
            const boxes = options.map((type) => 
                <CheckBoxComp
                    key={'checkbox_types_' + type.id}
                    label={type.label}
                    id={type.id}
                    checkboxProps = {{
                        name:type.id,
                        checked: (filter[type.id] == type.value),
                        onChange: this.props.onChangeCheckbox,
                        value: type.value
                    }}
                    subclassDefined={type.class ? type.class : ''}
                />
            );
            let okrOwner = filter.okr_owner || [];
            const okrUser = okrOwner.length ? okrOwner[0] : [];
            let krOwner = filter.kr_owner || [];
            const krUser = krOwner.length ? krOwner[0] : [];
            let okrCat = filter.okr_category || [];
            const okrCategory = okrCat.length ? okrCat[0] : [];
            return [
                ...boxes,
                <div key='search-okr-owner' className='search-okr-owner-wrapper'>
                    <SearchBoxComp
                        key='searchbox-okr-owner'
                        minLength="2"
                        wrapperClass="searchbox-rbr-owner"
                        url={"goal/getTeamAndOrgUsersList?team=true"}
                        inputProps={{
                            placeholder: t('Search for OKR owner'),
                        }}
                        fieldName='okr_owner'
                        renderResultComp={this.renderSearchOwnerList}
                        beforeFilterValues={this.filterOwnerLists}
                    />
                    <div className='search-rbr-list-wrapper'>
                        {
                            okrOwner.length ?
                            <div className='search-result-table'>
                                <OwnerList key={'owner_list_' + okrUser._id}  user={okrUser} fieldType='okr_owner' removeOwner={this.props.removeOwner} />
                            </div>
                            : ''
                        }
                    </div>
                </div>,
                <div key='search-kr-owner' className='search-kr-owner-wrapper'>
                    <SearchBoxComp
                        key='searchbox-kr-owner'
                        minLength="2"
                        wrapperClass="searchbox-rbr-owner"
                        url={"goal/getTeamAndOrgUsersList?team=true"}
                        inputProps={{
                            placeholder: t('Search for key result owner'),
                        }}
                        fieldName='kr_owner'
                        renderResultComp={this.renderSearchOwnerList}
                        beforeFilterValues={this.filterOwnerLists}
                    />
                    <div className='search-rbr-list-wrapper'>
                        {
                            krOwner.length ?
                            <div className='search-result-table'>
                                <OwnerList key={'kr_owner_list_' + krUser._id}  user={krUser} fieldType='kr_owner' removeOwner={this.props.removeOwner} />
                            </div>
                            : ''
                        }
                    </div>
                </div>,
                <TimeDropdownComp
                    key='okr_timedropdown'
                    filter={this.props.state.filter}
                    updateFilters={this.props.updateFilters}
                    filterOptions={this.props.filterOptions}
                    onChangeDateFilters={this.props.onChangeDateFilters}
                />,
                <div key='search-okr-category' className='search-kr-owner-wrapper'>
                    <SearchBoxComp
                        key='searchbox-okr-category'
                        minLength="2"
                        wrapperClass="searchbox-rbr-owner"
                        url={"goal/getGoalCategories?format=1"}
                        inputProps={{
                            placeholder: t("Search for category"),
                        }}
                        fieldName='okr_category'
                        renderResultComp={this.renderSearchOkrCatList}
                    />
                    <div className='search-rbr-list-wrapper'>
                        {
                            okrCat.length ?
                            <div className='search-result-table'>
                                <OkrCategoryList key={'kr_owner_list_' + okrCategory.id} item={okrCategory} fieldType='okr_category' removeOwner={this.props.removeOwner} />
                            </div>
                            : ''
                        }
                    </div>
                </div>
            ];
        }
        else if (filterType == '1' && this.executeModule) {
            const options = [
                {
                    id: 'hac',
                    label: t(`Hide ${actionLabel} comments`),
                    value: 1
                }
                /*,
                {
                    id: 'haw',
                    label: 'Hide archived workstreams',
                    value: 1
                }*/
            ];
            const boxes = options.map((type) => 
                <CheckBoxComp
                    key={'checkbox_types_' + type.id}
                    label={type.label}
                    id={type.id}
                    checkboxProps = {{
                        name:type.id,
                        checked: (filter[type.id] == type.value),
                        onChange: this.props.onChangeCheckbox,
                        value: type.value
                    }}
                />
            );
            let aiOwner = filter.ai_owner || [];
            const user = aiOwner.length ? aiOwner[0] : [];
            let aiWs = filter.ai_ws || [];
            const ws = aiWs.length ? aiWs[0] : [];
            return [
                    ...boxes,
                    <div key='search-ai-owner' className='search-ai-owner-wrapper'>
                        <SearchBoxComp
                            key='searchbox-ai-owner'
                            minLength="2"
                            wrapperClass="searchbox-rbr-owner"
                            url={"goal/getTeamAndOrgUsersList?team=true"}
                            inputProps={{
                                placeholder: t(`Search for ${actionLabel} owner`),
                            }}
                            fieldName='ai_owner'
                            renderResultComp={this.renderSearchOwnerList}
                            beforeFilterValues={this.filterOwnerLists}
                        />
                        <div className='search-rbr-list-wrapper'>
                            {
                                aiOwner.length ?
                                <div className='search-result-table'>
                                    <OwnerList key={'owner_list_' + user.userId}  user={user} fieldType='ai_owner' removeOwner={this.props.removeOwner} />
                                </div>
                                : ''
                            }
                        </div>
                    </div>,
                    <div key='search-ai-ws' className='search-ai-ws-wrapper'>
                        <SearchBoxComp
                            key='searchbox-ai-ws'
                            minLength="2"
                            wrapperClass="searchbox-rbr-owner"
                            url={"search/searchWorkstream"}
                            inputProps={{
                                placeholder: t("Search for workstream"),
                            }}
                            fieldName='ai_ws'
                            renderResultComp={this.renderSearchWsList}
                        />
                        <div className='search-rbr-list-wrapper'>
                            {
                                aiWs.length ?
                                <div className='search-result-table search-result-ws-table'>
                                    <WsList key={'ws_list_' + ws.id} ws={ws} fieldType='ai_ws' removeOwner={this.props.removeOwner} />
                                </div>
                                : ''
                            }
                        </div>
                    </div>,
                    <TimeDropdownComp
                        key='ai_timedropdown'
                        filter={this.props.state.filter}
                        updateFilters={this.props.updateFilters}
                        filterOptions={this.props.filterOptions}
                        onChangeDateFilters={this.props.onChangeDateFilters}
                    />
                ];
        }
        else if (filterType == '3' && this.meetingModule) {
            const options = [
                {
                    id: 'hmt',
                    label: t('Hide meeting topics and takeaways'),
                    value: 1
                }
            ];
            const boxes = options.map((type) => 
                <CheckBoxComp
                    key={'checkbox_types_' + type.id}
                    label={type.label}
                    id={type.id}
                    checkboxProps = {{
                        name:type.id,
                        checked: (filter[type.id] == type.value),
                        onChange: this.props.onChangeCheckbox,
                        value: type.value
                    }}
                />
            );
            return [
                ...boxes,
                <TimeDropdownComp
                    key='meet_timedropdown'
                    filter={this.props.state.filter}
                    updateFilters={this.props.updateFilters}
                    filterOptions={this.props.filterOptions}
                    onChangeDateFilters={this.props.onChangeDateFilters}
                />,
                <DropdownComp
                    key='dropdown_tag'
                    defaultValue={this.props.state.filter.meet_tag}
                    options={this.getMeetTagOptions()}
                    onChange={this.props.onChangeMeetTag}
                    optionRender={this.renderMeetTagOption}
                    renderSelectedItem={this.renderMeetTagOption}
                    wrapperClass='time-dropdown-wrapper meettag-dropdown-wrapper clear'
                    appendId="search-filters"
                />
            ]
        }
        else if (filterType == '4') {
            let rbrOwner = filter.rbr_owner || [];
            const user = rbrOwner.length ? rbrOwner[0] : [];
            return (
                <div className='search-rbr-owner-wrapper'>
                    <SearchBoxComp
                        key='searchbox-rbr-owner'
                        minLength="2"
                        wrapperClass="searchbox-rbr-owner"
                        url={"search/searchUser"}
                        inputProps={{
                            placeholder: t("Search for biz review owner"),
                        }}
                        fieldName='rbr_owner'
                        renderResultComp={this.renderSearchOwnerList}
                    />
                    <div className='search-rbr-list-wrapper'>
                        {
                            rbrOwner.length ?
                            <div className='search-result-table'>
                                <OwnerList key={'owner_list_' + user._id}  user={user} fieldType='rbr_owner' removeOwner={this.props.removeOwner} />
                            </div>
                            : ''
                        }
                    </div>
                </div>
            );
        }
        else if (filterType == '8') {
            let kpiOwner = filter.kpi_owner || [];
            const user = kpiOwner.length ? kpiOwner[0] : [];
            return [
                <CheckBoxComp
                    key='checkbox_hakpi'
                    label={t('Hide archived KPIs')}
                    id='hakpi'
                    checkboxProps = {{
                        name: 'hakpi',
                        checked: (filter.hakpi == 1),
                        onChange: this.props.onChangeCheckbox,
                        value: 1
                    }}
                />,
                <div key='search-kpi-owner' className='search-kpi-owner-wrapper'>
                    <SearchBoxComp
                        key='searchbox-kpi-owner'
                        minLength="2"
                        wrapperClass="searchbox-kpi-owner"
                        url={"search/searchUser"}
                        inputProps={{
                            placeholder: t("Search for KPI owner"),
                        }}
                        fieldName='kpi_owner'
                        renderResultComp={this.renderSearchOwnerList}
                    />
                    <div className='search-kpi-list-wrapper'>
                        {
                            kpiOwner.length ?
                            <div className='search-result-table'>
                                <OwnerList key={'owner_list_' + user.userId}  user={user} fieldType='kpi_owner' removeOwner={this.props.removeOwner} />
                            </div>
                            : ''
                        }
                    </div>
                </div>
            ];
        }
    }

    renderSearchOwnerList(values = [], inst) {
        if (values.length) {
            const fieldName = inst.props.fieldName;
            const useSourceData = fieldName == 'rbr_owner' || fieldName == 'kpi_owner';
            return (
                <div className='search-result-table'>
                {
                    values.map(m => (
                        <div className='search-result-row' key={`owner-${fieldName}-` + (useSourceData ?  m._source.id : m.userId)} onClick={() => this.props.onClickOwner(m, inst.props.fieldName, inst)}>
                            <div className='search-result-col search-result-icon-col'>
                                <img src={(useSourceData ? m._source.picture : m.picture)} width="30" height="30" style={{borderRadius: '50%'}} />
                            </div>
                            <div className='search-result-col search-result-text-col'>
                                <div className='truncate'>{(useSourceData ? m._source.description : m.fullName)}</div>
                            </div>
                        </div>
                    ))
                }
                </div>
            );
        } else {
            return null;
        }
    }

    renderSearchWsList(values = [], inst) {
        if (values.length) {
            return (
                <div className='search-result-table search-result-ws-table'>
                {
                    values.map(m => (
                        <div className='search-result-row' key={'ws-' + m.id} onClick={() => this.props.onClickOwner(m, inst.props.fieldName, inst)}>
                            <div className='search-result-col search-result-text-col'>
                                <div className='truncate'>{m.name}</div>
                                <div className='truncate subtext'>{m.teamName}</div>
                            </div>
                        </div>
                    ))
                }
                </div>
            );
        } else {
            return null;
        }
    }

    renderSearchOkrCatList(values = [], inst) {
        if (values.length) {
            let data1 = [];
            values.map(d => {
                if(d.sub_categories.length) {
                    data1 = data1.concat(...d.sub_categories);
                }
            });
            if (!data1.length) {
                return null;
            }
            else {
                return (
                    <div className='search-result-table search-result-ws-table'>
                    {
                        data1.map(m => (
                            <div className='search-result-row' key={'okrcat-' + m.id} onClick={() => this.props.onClickOwner(m, inst.props.fieldName, inst)}>
                                <div className='search-result-col search-result-text-col'>
                                    <div className='truncate'>{m.name}</div>
                                </div>
                            </div>
                        ))
                    }
                    </div>
                );
            }
        } else {
            return null;
        }
    }
   
    render() {
        const { t } = this.props;
        return (
            <div className="global-search-right-content">
                <div className="filter-by">{t('Filter by')}</div>
                <div className="label-with-dashes">
                    <div className="left">{t('Type')}</div>
                    <div className="right"></div>
                    <div className="clear"></div>
                </div>
                <div className="type-checkboxes">
                    { this.typeCheckboxes()}
                </div>
                <div className='advanced-options-wrapper'>
                    {
                        this.showMoreOptions()
                    }
                </div>
            </div>
        )
    }
}

GlobalSearchFiltersComp.defaultProps = {
    onChangeCheckbox: null,
    showAdvancedFilters: null,
    onChangeType: null,
    removeOwner: null,
    onChangeDateFilters: null
};

export default  withTranslation()(GlobalSearchFiltersComp);